// extracted by mini-css-extract-plugin
export default {"box":"customSelect_box__fcwBh","box__select":"customSelect_box__select__MYCg4","box__option":"customSelect_box__option__nF06I"};